module.exports = __webpack_public_path__ + "img/spirals.9519e56d.svg";